"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_v__car__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "38f656da-7292-48f5-93fd-794858d40247",
    "data-name": "a6117062-bb7f-4b53-bdd1-d2f28cbc4528",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "v-car-hi-dark"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,83.75c-6.92-8.5-12.42-15.5-22-23.19A61.33,61.33,0,0,0,80,47.75C63,48.85,48.36,58.93,40.76,69.4c-4,5.48-16.49,23.3-17,24.05-.31.44-.68,1-.89,1.32a35.89,35.89,0,0,0-6.44,21v8a12,12,0,0,0,12,12h136a12,12,0,0,0,12-12C176.42,104.91,162.92,89.25,143.42,83.75Z",
    transform: "translate(0 0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,133.75h-136a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12h136a12,12,0,0,0,12-12c0-.45,0-.91,0-1.36A12,12,0,0,1,164.42,133.75Z",
    transform: "translate(0 0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.92,127.75a28,28,0,1,0-54.83,8H82.76A28,28,0,0,0,83.92,127.75Z",
    transform: "translate(0 0.25)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.87,151.85a24,24,0,1,1,24-24A24,24,0,0,1,55.87,151.85Z",
    transform: "translate(0 0.25)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.87,149.75a24,24,0,0,1-24-23c0,.35,0,.7,0,1.05a24,24,0,0,0,48.09,0c0-.35,0-.7,0-1.05A24,24,0,0,1,55.87,149.75Z",
    transform: "translate(0 0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.87,127.75a28,28,0,1,0-54.83,8H162.7A28,28,0,0,0,163.87,127.75Z",
    transform: "translate(0 0.25)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,151.85a24,24,0,1,1,24-24A24,24,0,0,1,135.87,151.85Z",
    transform: "translate(0 0.25)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,149.75a24,24,0,0,1-24-23c0,.35,0,.7,0,1.05a24,24,0,0,0,48.09,0c0-.35,0-.7,0-1.05A24,24,0,0,1,135.87,149.75Z",
    transform: "translate(0 0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,127.81a12,12,0,1,1-12-12A12,12,0,0,1,147.89,127.81Z",
    transform: "translate(0 0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.89,127.81a12,12,0,1,1-12-12A12,12,0,0,1,147.89,127.81Z",
    transform: "translate(0 0.25)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.92,91.75h-4a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(0 0.25)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,83.75S117.84,62.22,98.38,57.27A70.43,70.43,0,0,0,87.53,55.6a54.26,54.26,0,0,0-5.68-.06,2,2,0,0,0-1.92,2V79.75a4,4,0,0,0,4,4h15.5V83.7a4,4,0,0,0,.5.05Z",
    transform: "translate(0 0.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.85,58a54.26,54.26,0,0,1,5.68.06,70.43,70.43,0,0,1,10.86,1.67c15.38,3.91,27.39,18.16,31.75,24h1.79S117.84,62.22,98.38,57.27A70.43,70.43,0,0,0,87.53,55.6a54.26,54.26,0,0,0-5.68-.06,2,2,0,0,0-1.92,2V60A2,2,0,0,1,81.85,58Z",
    transform: "translate(0 0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.33,57.65c-21.16,6.59-28.9,26.1-28.9,26.1h27.5a4,4,0,0,0,4-4V59.56A2,2,0,0,0,69.33,57.65Z",
    transform: "translate(0 0.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.33,57.64c-21.16,6.59-28.9,26.1-28.9,26.1h1.19c2.88-5.48,11.21-18.46,27.71-23.6a2,2,0,0,1,2.6,1.92v-2.5A2,2,0,0,0,69.33,57.64Z",
    transform: "translate(0 0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,127.81a12,12,0,1,1-12-12A12,12,0,0,1,67.89,127.81Z",
    transform: "translate(0 0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.89,127.81a12,12,0,1,1-12-12A12,12,0,0,1,67.89,127.81Z",
    transform: "translate(0 0.25)"
  })));
}

var _default = ic_v__car__dark;
exports.default = _default;